// components/CardRegistration.js
import React, { useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

function CardRegistration() {
  const currentUser = useSelector((state) => state.AuthReducer?.user);
  const [formData, setFormData] = useState({
    cardNumber: '',
    ownerName: '',
    cardType: 'SILVER',
    discountPercentage: 10,
    expiryDate: '',
    usageLimit: 1,
    phone: '',
    email: '',
    address: '',
    minimumPurchaseAmount: 0
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'cardNumber') {
      // Formater comme XXX-YYYY
      let formatted = value.replace(/[^0-9-]/g, '');
      
      if (formatted.length === 3 && !formatted.includes('-')) {
        formatted += '-';
      }
      
      if (formatted.length <= 8) {
        setFormData(prev => ({ ...prev, [name]: formatted }));
      }
    } else if (name === 'expiryDate') {
      // Formater la date
      const date = new Date(value);
      const formattedDate = date.toISOString().split('T')[0];
      setFormData(prev => ({ ...prev, [name]: formattedDate }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = () => {
    // Vérifier le format de la carte
    const cardPattern = /^\d{3}-\d{4}$/;
    if (!cardPattern.test(formData.cardNumber)) {
      setMessage({ type: 'error', text: 'Format: 001-2023 (3 chiffres-4 chiffres)' });
      return false;
    }

    if (!formData.ownerName.trim()) {
      setMessage({ type: 'error', text: 'Nom du propriétaire requis' });
      return false;
    }

    if (!formData.expiryDate) {
      setMessage({ type: 'error', text: 'Date d\'expiration requise' });
      return false;
    }

    return true;
  };

 // Dans CardRegistration.js - handleSubmit
const handleSubmit = async (e) => {
  e.preventDefault();
  
  if (!validateForm()) return;
  
  setLoading(true);
  setMessage({ type: '', text: '' });

  try {
    // Essayer d'abord le token du localStorage
    let token = localStorage.getItem('token');
    
    // Si pas de token, essayer de se connecter d'abord
    if (!token || token === 'null') {
      setMessage({
        type: 'warning',
        text: '⚠️ Tentative de connexion automatique...'
      });
      
      // Essayez de vous connecter (adaptez à votre système)
      try {
        const loginResponse = await axios.post('/api/auth/login', {
          email: 'admin@spintoss.com',
          password: 'admin123'
        }, {
          headers: { 'Content-Type': 'application/json' }
        });
        
        if (loginResponse.data.token) {
          token = loginResponse.data.token;
          localStorage.setItem('token', token);
        }
      } catch (loginError) {
        console.log('Connexion automatique échouée');
      }
    }

    const cardData = {
      cardNumber: formData.cardNumber,
      ownerName: formData.ownerName,
      cardType: formData.cardType,
      discountPercentage: parseInt(formData.discountPercentage),
      expiryDate: formData.expiryDate,
      usageLimit: parseInt(formData.usageLimit),
      minimumPurchaseAmount: parseInt(formData.minimumPurchaseAmount),
      clientInfo: {
        phone: formData.phone,
        email: formData.email,
        address: formData.address
      }
    };

    console.log('📤 Envoi vers port 5001:', cardData);

    // 🔥 CHANGER À 5001 DIRECTEMENT
    const response = await axios.post('/api/discountCards', cardData, {
      headers: { 
        Authorised: token || 'dev_token',
        'Content-Type': 'application/json'
      }
    });

    if (response.data.success) {
      setMessage({ 
        type: 'success', 
        text: `✅ Carte ${formData.cardNumber} créée ! ID: ${response.data.card?._id || ''}`
      });
      
      // Réinitialiser
      setFormData({
        cardNumber: '',
        ownerName: '',
        cardType: 'SILVER',
        discountPercentage: 10,
        expiryDate: '',
        usageLimit: 1,
        phone: '',
        email: '',
        address: '',
        minimumPurchaseAmount: 0
      });
    }

  } catch (error) {
    console.error('❌ Erreur création carte:', error);
    
    if (error.response?.status === 401) {
      // Erreur JWT - créer une route temporaire sans auth
      setMessage({
        type: 'error',
        text: 'Erreur d\'authentification. Le serveur attend un JWT valide.'
      });
      
      // Option: Ouvrir une fenêtre pour générer un token
      setTimeout(() => {
        if (window.confirm('Voulez-vous créer une carte en mode développement (sans auth)?')) {
          createCardWithoutAuth();
        }
      }, 1000);
    } else {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.message || `Erreur: ${error.message}`
      });
    }
  } finally {
    setLoading(false);
  }
};

// Fonction pour créer une carte sans authentification
const createCardWithoutAuth = async () => {
  try {
    const cardData = {
      cardNumber: formData.cardNumber,
      ownerName: formData.ownerName,
      discountPercentage: 10,
      expiryDate: formData.expiryDate,
      clientInfo: {
        phone: formData.phone,
        email: formData.email
      },
      status: 'ACTIVE'
    };

    // Route temporaire sur le serveur (voir étape 4)
    const response = await axios.post('/api/discountCards/dev-create', cardData);
    
    if (response.data.success) {
      setMessage({
        type: 'success',
        text: `✅ Carte créée en mode développement`
      });
    }
  } catch (error) {
    setMessage({
      type: 'error',
      text: 'Impossible de créer sans auth. Contactez l\'administrateur.'
    });
  }
};

  const generateTestCard = () => {
    const sequence = Math.floor(Math.random() * 999) + 1;
    const year = new Date().getFullYear();
    const cardNumber = `${sequence.toString().padStart(3, '0')}-${year}`;
    
    setFormData(prev => ({
      ...prev,
      cardNumber,
      ownerName: `Client Test ${sequence}`,
      phone: `+216 ${Math.floor(Math.random() * 10000000)}`,
      email: `client${sequence}@test.com`,
      expiryDate: new Date(year + 1, 11, 31).toISOString().split('T')[0]
    }));
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>🎫 Enregistrement Carte de Fidélité</h2>
        
        {message.text && (
          <div style={{
            ...styles.message,
            backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
            color: message.type === 'success' ? '#155724' : '#721c24',
            borderColor: message.type === 'success' ? '#c3e6cb' : '#f5c6cb'
          }}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formSection}>
            <h3 style={styles.sectionTitle}>Informations Carte</h3>
            
            <div style={styles.formGroup}>
              <label>Numéro de Carte *</label>
              <input
                type="text"
                name="cardNumber"
                value={formData.cardNumber}
                onChange={handleChange}
                placeholder="001-2023"
                style={styles.input}
                required
              />
              <small style={styles.helpText}>Format: 3 chiffres-4 chiffres (ex: 001-2023)</small>
            </div>

            <div style={styles.formGroup}>
              <label>Nom du Propriétaire *</label>
              <input
                type="text"
                name="ownerName"
                value={formData.ownerName}
                onChange={handleChange}
                placeholder="Jean Dupont"
                style={styles.input}
                required
              />
            </div>

            <div style={styles.row}>
              <div style={{...styles.formGroup, flex: 1}}>
                <label>Type de Carte</label>
                <select
                  name="cardType"
                  value={formData.cardType}
                  onChange={handleChange}
                  style={styles.input}
                >
                  <option value="SILVER">Silver</option>
                  <option value="GOLD">Gold</option>
                  <option value="PLATINUM">Platinum</option>
                </select>
              </div>

              <div style={{...styles.formGroup, flex: 1}}>
                <label>Réduction (%)</label>
                <input
                  type="number"
                  name="discountPercentage"
                  value={formData.discountPercentage}
                  onChange={handleChange}
                  min="1"
                  max="100"
                  style={styles.input}
                />
              </div>
            </div>

            <div style={styles.row}>
              <div style={{...styles.formGroup, flex: 1}}>
                <label>Date d'Expiration *</label>
                <input
                  type="date"
                  name="expiryDate"
                  value={formData.expiryDate}
                  onChange={handleChange}
                  style={styles.input}
                  required
                />
              </div>

              <div style={{...styles.formGroup, flex: 1}}>
                <label>Utilisations Max</label>
                <input
                  type="number"
                  name="usageLimit"
                  value={formData.usageLimit}
                  onChange={handleChange}
                  min="1"
                  style={styles.input}
                />
              </div>
            </div>
          </div>

          <div style={styles.formSection}>
            <h3 style={styles.sectionTitle}>Informations Client</h3>
            
            <div style={styles.formGroup}>
              <label>Téléphone *</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+216 XX XXX XXX"
                style={styles.input}
                required
              />
            </div>

            <div style={styles.formGroup}>
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="client@email.com"
                style={styles.input}
              />
            </div>

            <div style={styles.formGroup}>
              <label>Adresse</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Adresse complète..."
                style={{...styles.input, minHeight: '60px'}}
              />
            </div>

            <div style={styles.formGroup}>
              <label>Montant Minimum d'Achat (DT)</label>
              <input
                type="number"
                name="minimumPurchaseAmount"
                value={formData.minimumPurchaseAmount}
                onChange={handleChange}
                min="0"
                step="0.01"
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.buttonGroup}>
            <button
              type="button"
              onClick={generateTestCard}
              style={styles.secondaryButton}
            >
              Générer Carte Test
            </button>
            
            <button
              type="submit"
              disabled={loading}
              style={styles.primaryButton}
            >
              {loading ? (
                <>
                  <span style={styles.spinner}></span>
                  Enregistrement...
                </>
              ) : (
                '✅ Enregistrer la Carte'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: '20px',
    backgroundColor: '#f5f5f5',
    minHeight: '100vh'
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '10px',
    padding: '30px',
    maxWidth: '800px',
    margin: '0 auto',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
  },
  title: {
    color: '#333',
    textAlign: 'center',
    marginBottom: '30px',
    borderBottom: '2px solid #007bff',
    paddingBottom: '10px'
  },
  message: {
    padding: '12px 15px',
    borderRadius: '6px',
    marginBottom: '20px',
    border: '1px solid'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '25px'
  },
  formSection: {
    backgroundColor: '#f8f9fa',
    padding: '20px',
    borderRadius: '8px',
    border: '1px solid #dee2e6'
  },
  sectionTitle: {
    color: '#495057',
    marginTop: '0',
    marginBottom: '20px',
    fontSize: '18px'
  },
  formGroup: {
    marginBottom: '15px'
  },
  row: {
    display: 'flex',
    gap: '15px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ced4da',
    borderRadius: '4px',
    fontSize: '14px',
    boxSizing: 'border-box'
  },
  helpText: {
    display: 'block',
    color: '#6c757d',
    fontSize: '12px',
    marginTop: '5px'
  },
  buttonGroup: {
    display: 'flex',
    gap: '15px',
    justifyContent: 'flex-end',
    marginTop: '20px'
  },
  primaryButton: {
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    padding: '12px 25px',
    borderRadius: '5px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  secondaryButton: {
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    padding: '12px 25px',
    borderRadius: '5px',
    fontSize: '16px',
    cursor: 'pointer'
  },
  spinner: {
    width: '16px',
    height: '16px',
    border: '2px solid #ffffff',
    borderTopColor: 'transparent',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  }
};

export default CardRegistration;